import { processErrors, setDirtyState } from 'legacy/libs/utils'

const mixin = {
  displayName: 'ProcessErrorsMixin',

  processErrors(errors) {
    // TODO: refactor this, when react-form-tools #12 will be implemented
    if (!this.form) {
      throw Error('Please set ref={(ref) => (this.form = ref)} to <Form />')
    }
    setDirtyState(this.form, errors)
    processErrors(errors)
  },
}

export default mixin
